export const fieldTypeName = Object.freeze({
  Date: 'Date',
  Email: 'Email',
  Double: 'Double',
  RatingScale: 'RatingScale',
  Integer: 'Integer',
  PhoneNumber: 'PhoneNumber',
  Text: 'Text',
  File: 'File',
  RadioButton: 'RadioButton',
  Autocomplete: 'Autocomplete',
  Checkbox: 'Checkbox',
})

export const FieldTypeId = Object.freeze({
  [fieldTypeName.Date]: 1,
  [fieldTypeName.Email]: 2,
  [fieldTypeName.Double]: 3,
  [fieldTypeName.RatingScale]: 4,
  [fieldTypeName.Integer]: 5,
  [fieldTypeName.PhoneNumber]: 6,
  [fieldTypeName.Text]: 7,
  [fieldTypeName.File]: 8,
  [fieldTypeName.RadioButton]: 9,
  [fieldTypeName.Autocomplete]: 10,
  [fieldTypeName.Checkbox]: 11,
})

export function getFieldTypeNameById(fieldId) { return Object.entries(FieldTypeId).find((el) => el[1] === fieldId)?.[0] }
